import { Menu, Search, ShoppingBag, User } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getCart } from "../lib/cart";
import { Currency } from "../lib/currency";
import { t } from "../lib/i18n";
import CurrencySwitcher from "./CurrencySwitcher";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Header({ currency, onCurrency, onCart }: { currency: Currency; onCurrency: (v: Currency) => void; onCart: () => void }) {
  const { lang = "en" } = useParams();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const sync = () => setCount(getCart().reduce((sum, item) => sum + item.quantity, 0));
    sync();
    window.addEventListener("cart:changed", sync);
    return () => window.removeEventListener("cart:changed", sync);
  }, []);

  return (
    <>
      <div className="h-9 bg-[#EFE6D8] text-center text-xs font-semibold leading-9 text-[#0F172A] md:text-sm">{t(lang, "announcement")}</div>
      <header className="sticky top-0 z-40 border-b border-[rgba(15,23,42,0.08)] bg-[#F7F3EC]/82 backdrop-blur-2xl">
        <div className="container-page flex h-20 items-center gap-4">
          <Link to={`/${lang}`} className="flex shrink-0 items-center gap-3 font-black">
            <img src="/logo.svg" className="h-10 w-auto" alt="SellerSupply Shop" />
          </Link>
          <nav className="mx-4 hidden flex-1 items-center justify-center gap-7 text-sm font-semibold text-[#0F172A] lg:flex">
            <Link to={`/${lang}/products`}>{t(lang, "shop")}</Link>
            <Link to={`/${lang}/category/featured`}>{t(lang, "categories")}</Link>
            <Link to={`/${lang}/collections/new-arrivals`}>{t(lang, "newArrivals")}</Link>
            <Link to={`/${lang}/blog`}>{t(lang, "journal")}</Link>
            <Link to={`/${lang}/contact`}>{t(lang, "support")}</Link>
          </nav>
          <div className="hidden w-[260px] items-center rounded-full border border-[rgba(15,23,42,0.08)] bg-white/80 px-4 py-2.5 shadow-[0_12px_30px_rgba(15,23,42,0.05)] md:flex xl:w-[320px]">
            <Search size={18} className="text-slate-400" />
            <input className="w-full bg-transparent px-2 text-sm outline-none" placeholder={t(lang, "search")} />
          </div>
          <div className="hidden items-center gap-2 sm:flex">
            <LanguageSwitcher />
            <CurrencySwitcher value={currency} onChange={onCurrency} />
          </div>
          <Link className="hidden h-11 w-11 place-items-center rounded-full bg-white/70 shadow-[0_10px_24px_rgba(15,23,42,0.06)] hover:bg-white md:grid" to={`/${lang}/account`} aria-label={t(lang, "account")}><User size={19} /></Link>
          <button className="relative h-11 w-11 rounded-full bg-[#0F172A] text-white shadow-[0_14px_26px_rgba(15,23,42,0.18)]" onClick={onCart} aria-label={t(lang, "cart")}>
            <ShoppingBag className="mx-auto" size={19} />
            <span className="absolute -right-1 -top-1 grid h-5 min-w-5 place-items-center rounded-full bg-[#C89B5C] px-1 text-[11px] font-bold text-white">{count}</span>
          </button>
          <button className="grid h-11 w-11 place-items-center rounded-full bg-white/80 shadow-[0_10px_24px_rgba(15,23,42,0.06)] lg:hidden" aria-label="Menu"><Menu size={20} /></button>
        </div>
      </header>
    </>
  );
}
